import { z } from "zod";
import { env } from "../../env";
import {
  parseServiceInput,
  parseServiceOutput,
  requestConfig,
} from "../../globals";
import { type Wishlist, wishlist } from "../schemas/wishlist";

export const addWishlistItemProps = z
  .object({
    token: z.string(),
    productId: z.string(),
    variantId: z.string().optional(),
  })
  .extend(requestConfig.shape);

export type AddWishlistItemProps = z.infer<typeof addWishlistItemProps>;

export const addWishlistItem = async (
  args: AddWishlistItemProps,
): Promise<Wishlist> => {
  const {
    endpoint = env.ACCOUNT_SERVICE_URL,
    token,
    productId,
    variantId,
    proxyAuthSecret,
  } = parseServiceInput(addWishlistItemProps, args);

  const headers = new Headers({
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
    ...(proxyAuthSecret && { "X-NG-Proxy-Auth": proxyAuthSecret }),
  });

  const response = await fetch(`${endpoint}/v3/wishlist`, {
    method: "POST",
    headers,
    body: JSON.stringify({ productId, variantId }),
  });

  return parseServiceOutput(response, wishlist, {
    code: "MALFORMED_WISHLIST",
    message: "Wishlist is malformed",
  });
};
